import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppButtonComponent } from 'src/app/shared/components/app-button/app-button.component';
import { SectionMainService } from "../../../../../core/services/section-main.service";
import { CommonService } from 'src/app/core/services/common.service';
import { MemberService } from 'src/app/core/services/member.service';
import { StyleContentMainSection } from 'src/app/shared/models/styleContent';

@Component({
  selector: 'app-section-main',
  standalone: true,
  imports: [CommonModule, AppButtonComponent, RouterLink],
  templateUrl: './section-main.component.html',
  styleUrls: ['./section-main.component.scss']
})
export class SectionMainComponent {

  styles: { [key: string]: string };
  isMobile = window.innerWidth < 768;
  sectionMain: StyleContentMainSection = {} as StyleContentMainSection;
  currentBackgroundIndex = 0;
  carouselIntervalSelect: any;
  carouselInterval: any;
  images: any[] = [];

  buttonOptions: any = {
    borderRadius: '25px',
    buttonSize: 'btn btn-lg px-4 py-2'
  };

  loginButtonOptions: any = {
    buttonText: 'Entrar',
    borderRadius: '25px',
    buttonSize: 'btn btn-lg px-4 py-2 btn-secondary'
  };
  componentData: any = {}

  constructor(
    private sectionMainService: SectionMainService,
    private commonService: CommonService,
    private memberService: MemberService,
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobile = (event.target as Window).innerWidth < 768;
    this.setStyles(this.sectionMain);
  }

  ngOnInit(): void {
    this.getAllMembersNumber();
    this.setMainSectionStyles();
  }

  startCarousel(): void {
    if (this.images.length > 1) {
      this.carouselIntervalSelect = setInterval(() => {
        if (this.images.length > 0) {
          this.styles['--opacity'] = '0';
          setTimeout(() => {
            // Troca a imagem após o fade-out
            this.currentBackgroundIndex = (this.currentBackgroundIndex + 1) % this.images.length;
            this.setStyles(this.sectionMain);

            // Inicia o fade-in
            this.styles['--opacity'] = '1';
          }, 150);
        }
      }, this.carouselInterval ? this.carouselInterval * 1000 : 5000); // troca a cada 5 segundos
    } else {
      this.styles['--background-image'] = this.sectionMain.mainSectionDocuments && this.sectionMain.mainSectionDocuments?.length
        ? `url(${this.getImageUrlFromIndex(0)})` : 'none';
    }
  }

  private setMainSectionStyles(): void {
    this.sectionMainService.getSectionMain().subscribe({
      next: (res: StyleContentMainSection) => {
        if (res?.id) {
          this.sectionMain = res;
          this.carouselInterval = res.carouselInterval;
          this.getImages(res.mainSectionDocuments);

          this.setStyles(this.sectionMain);

          const prexfix = this.sectionMain.titleText.split('{quantidade_socios}')[0];
          const sufix = this.sectionMain.titleText.split('{quantidade_socios}')[1];

          this.componentData.prefixo = prexfix;
          this.componentData.sufixo = sufix;
          this.componentData.subtitle = this.sectionMain.textSub;
          this.componentData.specialCharacter = this.sectionMain.specialCharacter;

          this.startCarousel();
        }

        this.setButtonOptions(this.sectionMain);
      }
    });
  }

  private setButtonOptions(sectionMain: StyleContentMainSection): void {
    if (!sectionMain) {
      return;
    }

    if (sectionMain?.id) {
      this.buttonOptions.primaryColor = this.sectionMain.buttonColor;
      this.buttonOptions.buttonTextColor = this.sectionMain.buttonTextColor;
      this.buttonOptions.buttonBorderColor = this.sectionMain.buttonBorderColor || 'none';
      this.buttonOptions.buttonBorderWidth = this.sectionMain.hasButtonBorder ? '1px' : 'none';
      this.buttonOptions.btnBorderHover = this.sectionMain.buttonBorderWhenHovering,
        this.buttonOptions.btnBorderHoverColor = this.sectionMain.buttonBorderColorWhenHovering,
        this.buttonOptions.btnTextHoverColor = this.sectionMain.buttonTextColorWhenHovering,
        this.buttonOptions.btnHoverColor = this.sectionMain.buttonColorWhenHovering
    }
    this.buttonOptions.buttonText = this.sectionMain.textJoinPlanButton;
    this.buttonOptions.borderRadius = '25px';
    this.buttonOptions.buttonBorderWidth = this.sectionMain.hasButtonBorder ? '1px' : 'none';
    this.buttonOptions.buttonSize = 'btn btn-lg px-4 py-2';
  }

  private setStyles(sectionMain: StyleContentMainSection) {
    if (!sectionMain) {
      return;
    }

    this.styles = {
      '--show-section': sectionMain.showSection ? 'flex' : 'none',
      '--background-color': sectionMain.backgroundIsImage ? 'none' : sectionMain.backgroundColor,
      '--counter-color': sectionMain.socialAccountantColor,
      '--counter-font-size': this.commonService.getRemFontSize(sectionMain.counterSize, this.isMobile),
      '--title-color': sectionMain.titleColor,
      '--title-font-size': this.commonService.getRemFontSize(sectionMain.titleSize, this.isMobile),
      '--special-character-color': sectionMain.specialCharacterColor,
      '--special-character-size': this.commonService.getRemFontSize(sectionMain.specialCharacterSize, this.isMobile),
      '--subtitle-color': sectionMain.subtitleColor,
      '--subtitle-font-size': this.commonService.getRemFontSize(sectionMain.subtitleSize, this.isMobile),
      '--background-image': this.sectionMain.mainSectionDocuments && this.sectionMain.mainSectionDocuments?.length
        ? `url(${this.getImageUrlFromIndex(this.currentBackgroundIndex)})`
        : 'none',
      '--element-position': this.getFlexPosition(sectionMain.elementPosition || 'CENTRO'),
      '--opacity': '1',
      '--side-buttons-color': sectionMain.sideButtonsColor,
      '--side-buttons-icon-color': sectionMain.sideButtonsIconColor === true ? 'black' : 'white'
    };
  }

  goToNextImage() {
    if (this.currentBackgroundIndex == this.images.length - 1) {
      this.currentBackgroundIndex = 0;
      this.styles['--background-image'] = this.sectionMain.mainSectionDocuments && this.sectionMain.mainSectionDocuments?.length
        ? `url(${this.getImageUrlFromIndex(this.currentBackgroundIndex)})` : 'none';
    } else {
      this.currentBackgroundIndex = this.currentBackgroundIndex + 1;
      this.styles['--background-image'] = this.sectionMain.mainSectionDocuments && this.sectionMain.mainSectionDocuments?.length
        ? `url(${this.getImageUrlFromIndex(this.currentBackgroundIndex)})` : 'none';
    }
  }

  goToPrevImage() {
    if (this.currentBackgroundIndex === 0) {
      this.currentBackgroundIndex = this.images.length - 1;
      this.styles['--background-image'] = this.sectionMain.mainSectionDocuments && this.sectionMain.mainSectionDocuments?.length
        ? `url(${this.getImageUrlFromIndex(this.currentBackgroundIndex)})` : 'none';
    } else {
      this.currentBackgroundIndex = this.currentBackgroundIndex - 1;
      this.styles['--background-image'] = this.sectionMain.mainSectionDocuments && this.sectionMain.mainSectionDocuments?.length
        ? `url(${this.getImageUrlFromIndex(this.currentBackgroundIndex)})` : 'none';
    }

  }


  private getFlexPosition(position: string): string {
    switch (position) {
      case 'TOPO':
        return 'flex-start';
      case 'BASE':
        return 'flex-end';
      case 'CENTRO':
      default:
        return 'center';
    }
  }

  getImages(documents: any) {
    documents.forEach((d: any) => {
      const doc: any = this.commonService.getImageStr(d.document.id);
      this.images.push(doc);
    });
  }

  getImageUrlFromIndex(index: number): string {
    const document = this.images?.[index];
    if (!document) return '';
    return document;
  }


  getImageUrl(sectionMain: any) {
    if (sectionMain.defaultStyle) {
      return sectionMain.backgroundImageUrl;
    }
    return this.commonService.getImageStr(sectionMain.document.id);
  }

  getAllMembersNumber(): void {
    this.memberService.getAmountMembersBySituation().subscribe({
      next: (res: any) => {
        this.componentData.highlight = res;
      }
    });
  }
}
